import React from 'react';
import ChannelList from '../../channels.json';

class ChannelLink extends React.Component {

  render() {
    let logoUrl = 'img/channelLogos/' + ChannelList[this.props.channelId].link + '.png';
    let playerBaseUrl = 'https://radioplayer.vrt.be/';
    let host = window.location.host;
    if ((host.indexOf('localhost') !== -1) || (host.indexOf('dev') !== -1)) {
      playerBaseUrl = 'https://radioplayer-dev.vrt.be/';
    } else if (host.indexOf('stag') !== -1) {
      playerBaseUrl = 'https://radioplayer-stag.vrt.be/';
    }
    let playerLink = playerBaseUrl + ChannelList[this.props.channelId].link + '/index.html';
    return (
      <div className="channelLink">
        <a href={playerLink} target="_parent">
          <div className="channelLogoContainer">
            <img src={logoUrl} alt='' />
          </div>
          <p className="hidden">
            {ChannelList[this.props.channelId].info.name}
          </p>
        </a>
      </div>
    );
  }

}

export default ChannelLink;